module.exports = __webpack_public_path__ + "img/神鸟.f08de906.gif";